//
//
//

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$router.push({
                path: '/acties/sexmetkerst'
            })
        });
    },
    head() {
        return {
            link: [{
                rel: 'canonical',
                href: 'https://meidenvanholland.nl/acties/sexmetkerst'
            }],
            meta: [
            { hid: 'robots', name: 'robots', content: 'noindex' },
            ]
        }
    },
}
